import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Typography } from "@mui/material";

interface TriggerFigureCheckboxProps {
  id: string;
  expenditureType: string;
  triggerSum: number;
  checked: boolean;
  setChecked: (value: boolean) => void;
}

const TriggerFigureCheckbox = ({
  id,
  expenditureType,
  triggerSum,
  checked,
  setChecked,
}: Readonly<TriggerFigureCheckboxProps>) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(event) => setChecked(event.target.checked)}
            inputProps={{ "aria-label": "controlled" }}
            sx={{
              marginRight: { xs: "8px", sm: 0 },
              marginBottom: { xs: "8px", sm: 0 },
            }}
          />
        }
        label={
          <Typography textAlign="left">
            The total value you have entered for <b>{expenditureType}</b> is
            higher than the monthly national average of <b>£{triggerSum}</b>. If
            this is incorrect, please review and update your figures. If the
            value is correct, please tick the box to continue.
          </Typography>
        }
        id={id}
        sx={{
          margin: 2,
        }}
        labelPlacement="end"
      />
    </FormGroup>
  );
};

export default TriggerFigureCheckbox;
